'use strict';

import BaseService from './base.service';

class SpendingTypesService extends BaseService {
    /* @ngInject */
    constructor(
        SpendingType, SegaUser
    ) {
        super(SpendingType, SegaUser);
    }
}

export default SpendingTypesService;
